module.exports = __webpack_public_path__ + "img/linkem-img-test-wide.595a9bb3.jpg";